import PropTypes from 'prop-types'
import { Download, FileText, Printer } from 'lucide-react'

import { PDF_ACTION } from '../../../utils/pdfActions'

/** The View / Print / Download entries of a summary page's Actions menu, e.g. noun = "WO". */
export const pdfActionItems = (noun, onAction) => [
  { label: `View ${noun}`, icon: FileText, onClick: () => onAction(PDF_ACTION.VIEW) },
  { label: `Print ${noun}`, icon: Printer, onClick: () => onAction(PDF_ACTION.PRINT) },
  { label: `Download ${noun}`, icon: Download, onClick: () => onAction(PDF_ACTION.DOWNLOAD) }
]

/** The same entries as desktop dropdown buttons; onClose closes the menu first. */
export const PdfActionMenuItems = ({ noun, onAction, onClose }) =>
  pdfActionItems(noun, onAction).map(({ label, icon: Icon, onClick }) => (
    <button
      key={label}
      type='button'
      onClick={() => {
        onClose?.()
        onClick()
      }}
      className='flex w-full items-center gap-3 px-4 py-2.5 text-left text-[14px] text-[#0A1628] transition-colors hover:bg-[#F8FAFC]'
    >
      <Icon className='h-4 w-4 text-[#475569]' />
      {label}
    </button>
  ))

PdfActionMenuItems.propTypes = {
  noun: PropTypes.string.isRequired,
  onAction: PropTypes.func.isRequired,
  onClose: PropTypes.func
}
